export default __webpack_public_path__ + "static/media/selfPortrait.d431c52e.jpg";